<template>
  <div class="bg-secondary-3" v-if="hasPei != null">
    <div class="bg-white py-3 px-4 rounded">
      <div class="row mt-4">
        <div class="col-12 d-flex">
          <i class="fas fa-info-circle text-orange mr-2 mt-1"></i>
          <p class="font-weight-normal font-18" v-if="hasPei">
            Información Adicional del Informe de Progreso
          </p>
          <p class="font-weight-normal font-18" v-if="hasPei === false">
            No se encontró la información de PEI
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div v-for="item in rows" :key="item.weekId" class="mb-2">
            <AdditionalProgressInformationRow
              :item="item"
              @edit="(e) => $emit('edit', e)"
              @view="(e) => $emit('view', e)"
              @download="(e) => $emit('download', e)"
              @download-discussion="(e) => $emit('download-discussion', e)"
              @saved="onSaveAmend()"
              @save-discussion="onSaveDiscussion()"
              @load-history="onLoadHistory"
              @refresh-additional-information="
                getAdditionalProgressInformation()
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdditionalProgressInformationRow from './AdditionalProgressInformationRow.vue';
import peiService from '@/services/pei/peiAcademicProgressCalendar.js';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'AdditionalProgressInformation',
  components: {
    AdditionalProgressInformationRow,
  },
  mixins: [alert],
  data: () => ({
    rows: [],
    hasPei: null,
  }),
  mounted() {
    this.getAdditionalProgressInformation();
  },
  props: {
    sie: {
      type: Number,
      default: null,
    },
    academicYearId: {
      type: Number,
      default: 0,
    },
    onlyPsc: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async getAdditionalProgressInformation() {
      try {
        const { data } = await peiService.getAdditionalProgressInformation(
          this.sie,
          this.academicYearId,
          this.onlyPsc
        );
        this.rows = data.map((x) => {
          return { ...x, history: [], hasMoreHistory: false };
        });
        this.hasPei = true;
      } catch (error) {
        this.ShowToast('Alerta', `${error.response.data.message}.`, 'error');
        this.hasPei = false;
      }
    },
    async onSaveAmend() {
      await this.getAdditionalProgressInformation();
      this.$emit('saved');
    },
    async onSaveDiscussion() {
      await this.getAdditionalProgressInformation();
      this.$emit('onSaveDiscussion');
    },
    async onLoadHistory(item, size) {
      const payload = {
        pageIndex: 1,
        pageSize: size,
        peiAcademicProgressId: item.academicProgressId,
      };
      const { data: result } = await peiService.getDiscussionLogHistory(
        payload
      );
      item.history = result.data;
      item.hasMoreHistory = result.totalItemCount > result.count;
    },
  },
};
</script>

<style lang="scss" scoped></style>
